import { InputEntity } from "..";

export class ContactInput extends InputEntity {
  constructor(
    public readonly name: string,
    public readonly email: string,
    public readonly title: string,
    public readonly message: string
  ) {
    super();
  }
}
